//Custom components
import StatCard from '../../../UI/Card/StatCard';

const AffordableUnitsCreatedWidget = ({ count }: { count: number }) => {
  return <StatCard title='Affordable Unit Created' stat={count} />;
};

export default AffordableUnitsCreatedWidget;
